<template>
  <section class="py-4">
    <b-container>
      <b-breadcrumb>
        <b-breadcrumb-item active>
          <b-icon aria-hidden="true" icon="people-fill" scale="1.25" shift-v="1.25"></b-icon>
          Users
        </b-breadcrumb-item>
      </b-breadcrumb>

      <b-modal id="delete-user" hide-footer title="Delete User">
        <delete-user-modal @userDeleted="userDeleted" />
      </b-modal>

      <b-card>
        <b-card-text>
          <b-row class="mb-3 mt-4">
            <b-col id="filter-input-col" cols="12" lg="8" md="8" sm="12">
              <filter-users
                :filter.sync="filter"
                :per-page.sync="perPage"
                @get-users="getUsers"
                class="mb-4 mr-2 pl-1"
              />
            </b-col>
            <b-col id="user-create-col">
              <div class="float-right">
                <b-button pill squared variant="success" @click="goToCreateUser"
                  >Create User
                  <b-icon icon="person-plus-fill"></b-icon>
                </b-button>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="Object.keys(userRoleCounts).length > 0">
            <b-col>
              <div
                class="d-flex justify-content-between mb-3 text-center"
                style="border:1px solid #17a2b8; border-radius:0.5rem;"
              >
                <div
                  v-for="(count, role) in userRoleCounts"
                  :key="role"
                  class="p-2 flex-fill"
                  style="color: #17a2b8;"
                >
                  {{ role }}s: <strong>{{ count }}</strong>
                </div>
              </div>
            </b-col>
          </b-row>

          <users-table :busy="busy" :per-page="perPage" :users="users" v-if="showUsersTable" />
          <b-card v-else>
            <b-card-text style="font-size: large;" class="text-center">
              Please use the search input above to filter and view the users.
            </b-card-text>
          </b-card>
        </b-card-text>
      </b-card>
    </b-container>
  </section>
</template>

<script>
  import FilterUsers from './users/FilterUsers';
  import DeleteUserModal from './users/DeleteUserModal';
  import UsersTable from './users/UsersTable';
  import _ from 'lodash';

  export default {
    name: 'AdminPanel',
    components: {
      UsersTable,
      FilterUsers,
      DeleteUserModal,
    },
    metaInfo() {
      let metaTitle = this.$appName + 'Admin Panel';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        busy: false,
        filter: '',
        perPage: 10,
        users: [],
        userRoleCounts: {},
        showUsersTable: false,
      };
    },
    mounted() {
      // this.getUsers();
    },
    methods: {
      goToCreateUser() {
        this.$router.push({ name: 'salesforce-user-create' });
      },
      async getUsers() {
        this.showUsersTable = true;
        this.busy = true;
        let param = (this.filter || '').trim().replace(/\s+/g, ' ');

        await axios
          .get(`/api/salesforce/users?searchString=${param}`)
          .then(results => {
            this.users = _.orderBy(
              _.sortBy(results.data.items, ['createdDate', 'name']),
              ['createdDate', 'name'],
              ['desc', 'asc'],
            );
            this.userRoleCounts = _.countBy(this.users, 'simRole');
          })
          .catch(error => {
            console.error(error);
            this.$bvToast.toast('Error getting users data', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
          });
        this.busy = false;
      },
      userDeleted() {
        this.$bvModal.hide('delete-user');
        // this.getUsers();
      },
    },
  };
</script>
